module.exports = __webpack_public_path__ + "static/img/10.bc55c75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/10.jpg
// module id = TV5D
// module chunks = 0